import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ElementRef, HostListener} from '@angular/core';


@Component({
	selector: 'component-button',
	templateUrl: './component.button.html',
	styleUrls: ['./component.button.css']
})

export class ComponentButton implements OnInit, AfterViewInit {

  @Input() theme: any; //主题
  @Input() isDisabled: boolean; //是否置灰
  @Output() onExit = new EventEmitter<any>(); //退出事件
  @Output() onCommit = new EventEmitter<any>(); //提交事件

  constructor(private el: ElementRef) {}

  ngOnInit() {



  }

  ngAfterViewInit() {

  }

  // 按钮点击事件
  buttonHandleClick(i){
    let target = this.el.nativeElement.querySelector('.button-'+i);
    // 如果提交按钮置灰并且这个按钮不是退出类型的按钮则不执行事件
    if(!target.classList.contains('cancel') && target.classList.contains('disabled')){
      return false;
    }else{
      if(target.classList.contains('cancel')){
        this.onExit.emit();
      }else{
        this.onCommit.emit();
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/component-ui/button/component.button.ts